<script>
import { Line } from "vue-chartjs";
import * as soluhaApi from "@/soluhaApi";
// plugin agar bisa tambah attribute chartArea Backgroud
const changeBackgroundPlugin = {
  beforeDraw: function (chart) {
    if (
      chart.config.options.chartArea &&
      chart.config.options.chartArea.backgroundColor
    ) {
      var ctx = chart.chart.ctx;
      var chartArea = chart.chartArea;

      ctx.save();
      ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
      ctx.fillRect(
        chartArea.left,
        chartArea.top,
        chartArea.right - chartArea.left,
        chartArea.bottom - chartArea.top
      );
      ctx.restore();
    }
  },
};

export default {
  extends: Line,
  props: ["pageNumber", "divisi", "bulan", "cabang"],
  data() {
    return {
      // variabel yang akan diisi dengan nilai gradient
      gradientStroke: null,

      chartData: {
        labels: Array(10)
          .fill()
          .map((_, i) => `${++i}`),
        datasets: [
          {
            data: Array(10)
              .fill()
              .map(() => `${Math.floor(Math.random() * 50)}`),
            borderColor: "#80b6f4",
            pointBorderColor: "#80b6f4",
            pointBackgroundColor: "#80b6f4",
            pointHoverBackgroundColor: "#80b6f4",
            pointHoverBorderColor: "#80b6f4",
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
            borderWidth: 4,
          },
        ],
      },
      options: {
        chartArea: {
          backgroundColor: "#F5F6FB",
        },
        bezierCurve: false,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "#A0A3BD",
                fontStyle: "light",
                fontSize: 12,
                beginAtZero: true,
                padding: 10,
                stepSize: 10,
              },
              gridLines: {
                zeroLineColor: "transparent",
                lineWidth: 8,
                color: "#FCFCFC",
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                zeroLineColor: "transparent",
                lineWidth: 8,
                color: "#FCFCFC",
              },
              ticks: {
                padding: 4,
                fontColor: "#A0A3BD",
                fontStyle: "light",
                fontSize: 12,
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
              },
            },
          ],
        },
      },
    };
  },

  watch: {
    bulan: function (newVal, oldVal) {
      this.getKehadiran(this.divisi, newVal, this.pageNumber, this.cabang);
    },

    divisi: function (newVal, oldVal) {
      this.getKehadiran(newVal, this.bulan, this.pageNumber, this.cabang);
    },

    pageNumber: function (newVal, oldVal) {
      this.getKehadiran(this.divisi, this.bulan, newVal, this.cabang);
    },

    cabang: function (newVal, oldVal) {
      this.getKehadiran(this.divisi, this.bulan, this.pageNumber, newVal);
    },
  },

  methods: {
    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },

    async getKehadiran(divisi, bulan, pageNumber, cabang) {
      // ambil object tanggal dari bulan yang dipilih
      let date = new Date(bulan);
      let month = date.getMonth();
      let year = date.getFullYear();
      // ambil date start dan date end
      let dateStart = new Date(year, month, 2);
      let dateEnd = new Date(year, month + 1, 2);
      // ambil data dari api
      let dataKehadiran = await soluhaApi.getGrafikKehadiran(
        dateStart.getTime(),
        dateEnd.getTime(),
        divisi,
        cabang
      );
      // data chart
      let data = Object.values(dataKehadiran.presensiBerkala);
      let label = Array(31)
        .fill()
        .map((_, i) => `${++i}`);
      this.chartData.datasets[0].data = this.paginate(data, 11, pageNumber);
      this.chartData.labels = this.paginate(label, 11, pageNumber);
      // render chart
      this.renderChart(this.chartData, this.options);
    },
  },

  mounted() {
    this.getKehadiran(this.divisi, this.bulan, this.pageNumber, this.cabang);
    // set grafik size
    this.$refs.canvas.style.width = "712px";
    this.$refs.canvas.style.maxHeight = "200px";
    // add plugin
    this.addPlugin(changeBackgroundPlugin);
    // set gradient line
    this.gradientStroke = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(500, 0, 100, 0);
    this.gradientStroke.addColorStop(0, "#17EAAC");
    this.gradientStroke.addColorStop(1, "#45AFEE");

    // add gradient to data
    this.chartData.datasets[0].borderColor = this.gradientStroke;
    this.chartData.datasets[0].pointBorderColor = this.gradientStroke;
    this.chartData.datasets[0].pointBackgroundColor = this.gradientStroke;
    this.chartData.datasets[0].pointHoverBackgroundColor = this.gradientStroke;
    this.chartData.datasets[0].pointHoverBorderColor = this.gradientStroke;
  },
};
</script>
